export default "__VITE_ASSET__CnI41mfa__"